<template>
  <router-link
    :to="to"
    class="btn btn-outline-primary"
  >Edit</router-link>
</template>

<script>
export default {
  name: 'EditButton',
  props: {
    to: {
      default() { return {path: 'edit', append: true} },
    },
  },
}
</script>
